export default function dailyOffersTimerTemplate(options = {}) {
  const { variant } = options;

  const isCompact = variant === 'compact';
  const isMobile = !isCompact && window.isMobileDevice;

  if (isCompact) {
    return compactTemplate();
  }

  if (isMobile) {
    return mobileTemplate();
  }

  return desktopTemplate();
}

function desktopTemplate() {
  return `
    <div class="daily_offers__timer__container">
      <div class="daily-offer-timer-title">До конца акции:</div>
      <div class="daily_offers__timer__wrapper">
        ${defaultIcon()}
        ${timerSkeleton()}
        ${timer()}
      </div>
    </div>
  `;
}

function mobileTemplate() {
  return `
    <div class="daily_offers__timer__container">
      <div class="daily_offers__timer__wrapper">
        ${mobileDefaultIcon()}
        ${timerSkeleton()}
        ${timer()}
      </div>
      <div class="daily-offer-timer-title">до конца акции</div>
    </div>
  `;
}

function compactTemplate() {
  return `
    <div class="daily_offers__timer__container daily_offers__timer-compact">
      <div class="daily_offers__timer__wrapper">
        ${compactIcon()}
        ${timerSkeleton()}
        ${timer({ withoutText: true })}
      </div>
    </div>
  `;
}

function timerSkeleton() {
  return `
    <div class="daily-offers-timer-skeleton">
      <div class="daily-offers-timer-skeleton__block"></div>
      <div class="daily-offers-timer-skeleton__block"></div>
      <div class="daily-offers-timer-skeleton__block"></div>
    </div>
  `;
}

function timer({ withoutText = false } = {}) {
  return `
    <div class="daily_offers__timer daily-offer-timer hidden">
      <div class="daily_offers__timer_hours">
      ${withoutText ? '<div class="timer-hours">00</div>' : '<span class="timer-hours">00</span> д'}
      </div>
      <div class="daily_offers__timer_colon">:</div>
      <div class="daily_offers__timer_minutes">
      ${withoutText ? '<div class="timer-minutes">00</div>' : '<span class="timer-minutes">00</span> ч'}
      </div>
      <div class="daily_offers__timer_colon">:</div>
      <div class="daily_offers__timer_seconds">
      ${withoutText ? '<div class="timer-seconds">00</div>' : '<span class="timer-seconds">00</span> м'}
      </div>
    </div>
  `;
}

function defaultIcon() {
  return `
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 23.3334C16.4754 23.3334 18.8494 22.35 20.5997 20.5997C22.35 18.8494 23.3334 16.4754 23.3334 14C23.3334 11.5247 22.35 9.15072 20.5997 7.40038C18.8494 5.65004 16.4754 4.66671 14 4.66671C11.5247 4.66671 9.15072 5.65004 7.40038 7.40038C5.65004 9.15072 4.66671 11.5247 4.66671 14C4.66671 16.4754 5.65004 18.8494 7.40038 20.5997C9.15072 22.35 11.5247 23.3334 14 23.3334ZM14 2.33337C15.5321 2.33337 17.0492 2.63514 18.4647 3.22145C19.8801 3.80775 21.1663 4.66711 22.2496 5.75046C23.333 6.83381 24.1923 8.11994 24.7786 9.5354C25.3649 10.9509 25.6667 12.468 25.6667 14C25.6667 17.0942 24.4375 20.0617 22.2496 22.2496C20.0617 24.4375 17.0942 25.6667 14 25.6667C7.54837 25.6667 2.33337 20.4167 2.33337 14C2.33337 10.9058 3.56254 7.93839 5.75046 5.75046C7.93839 3.56254 10.9058 2.33337 14 2.33337ZM13.7084 7.58337C14.1916 7.58337 14.5834 7.97512 14.5834 8.45837V14.2917L19.7175 17.3136C20.1208 17.5511 20.2516 18.0728 20.008 18.4724C19.7688 18.8647 19.2583 18.9913 18.8635 18.7563L12.8334 15.1667V8.45837C12.8334 7.97512 13.2251 7.58337 13.7084 7.58337Z" fill="#C11800"/>
    </svg>
  `;
}

function mobileDefaultIcon() {
  return `
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 15.8334C11.1797 15.8334 12.7906 15.1661 13.9783 13.9784C15.1661 12.7907 15.8333 11.1797 15.8333 9.50004C15.8333 7.82034 15.1661 6.20943 13.9783 5.0217C12.7906 3.83397 11.1797 3.16671 9.5 3.16671C7.82029 3.16671 6.20939 3.83397 5.02166 5.0217C3.83393 6.20943 3.16667 7.82034 3.16667 9.50004C3.16667 11.1797 3.83393 12.7907 5.02166 13.9784C6.20939 15.1661 7.82029 15.8334 9.5 15.8334ZM9.5 1.58337C10.5396 1.58337 11.5691 1.78814 12.5296 2.18599C13.4901 2.58384 14.3628 3.16698 15.0979 3.90211C15.8331 4.63724 16.4162 5.50997 16.814 6.47046C17.2119 7.43096 17.4167 8.46041 17.4167 9.50004C17.4167 11.5997 16.5826 13.6133 15.0979 15.098C13.6133 16.5826 11.5996 17.4167 9.5 17.4167C5.12208 17.4167 1.58333 13.8542 1.58333 9.50004C1.58333 7.40041 2.41741 5.38677 3.90207 3.90211C5.38673 2.41745 7.40037 1.58337 9.5 1.58337ZM9.30208 5.14587C9.63 5.14587 9.89583 5.4117 9.89583 5.73962V9.69796L13.3797 11.7486C13.6534 11.9097 13.7421 12.2637 13.5768 12.5349C13.4145 12.8011 13.0681 12.887 12.8002 12.7275L8.70833 10.2917V5.73962C8.70833 5.4117 8.97416 5.14587 9.30208 5.14587Z" fill="#C11800"/>
    </svg>
  `;
}

function compactIcon() {
  return `
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 12.5C8.82608 12.5 10.0979 11.9732 11.0355 11.0355C11.9732 10.0979 12.5 8.82608 12.5 7.5C12.5 6.17392 11.9732 4.90215 11.0355 3.96447C10.0979 3.02678 8.82608 2.5 7.5 2.5C6.17392 2.5 4.90215 3.02678 3.96447 3.96447C3.02678 4.90215 2.5 6.17392 2.5 7.5C2.5 8.82608 3.02678 10.0979 3.96447 11.0355C4.90215 11.9732 6.17392 12.5 7.5 12.5ZM7.5 1.25C8.32076 1.25 9.13349 1.41166 9.89177 1.72575C10.6501 2.03984 11.3391 2.50022 11.9194 3.08058C12.4998 3.66095 12.9602 4.34994 13.2742 5.10823C13.5883 5.86651 13.75 6.67924 13.75 7.5C13.75 9.1576 13.0915 10.7473 11.9194 11.9194C10.7473 13.0915 9.1576 13.75 7.5 13.75C4.04375 13.75 1.25 10.9375 1.25 7.5C1.25 5.8424 1.90848 4.25269 3.08058 3.08058C4.25269 1.90848 5.8424 1.25 7.5 1.25ZM7.34375 4.0625C7.60263 4.0625 7.8125 4.27237 7.8125 4.53125V7.65625L10.5629 9.27515C10.779 9.40233 10.8491 9.68183 10.7185 9.89591C10.5904 10.1061 10.3169 10.1739 10.1054 10.048L6.875 8.125V4.53125C6.875 4.27237 7.08487 4.0625 7.34375 4.0625Z" fill="#E01B00"/>
    </svg>
  `;
}
